import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** DELETE `/mom/work-order/{id}`。僅草稿；無 body。 */
export async function deleteWorkOrder(id) {
  const { data: raw } = await request.delete(`/mom/work-order/${id}`);
  return parseVer4DetailResponse(raw);
}
